<template>
	<div>
		<form class="form-container" @submit.prevent="sendKeys">
			<label v-if="platform==='shippypro'" for="key">
			{{ $t('copyLiveShippyProKeys') }}:
			</label>
			<label v-if="platform==='eurosender'" for="key">
			{{ $t('copyLiveEuroSenderKeys') }}
				<b-button
					class="questionMark"
					v-b-tooltip.hover
					:title="$t('liveEuroSenderKeysTooltip')"
				>?</b-button>
			</label>

			<input 
				placeholder="Key" 
				v-model="key" 
				type="text" 
				name="key" 
				v-on:input="errors = null"
				:class="{ 'error-boarder': $v.key.$error }"
				@blur="$v.key.$touch()"
				value />
			<div style="width:100%;" v-if="$v.key.$error">
				<p v-if="!$v.key.required" class="errorMessage">
					{{ $t('keyReq') }}
				</p>
			</div>

			<button :disabled="$v.$invalid" class="add-btn" type="submit" name="button">
				{{ $t('save') }}
			</button>

			<div v-if="this.errors" class="errorMessage">
				{{ this.errors }}
			</div>
		</form>
		<div>{{ $t('eurosenderSignUp') }} <a target="_blank" href="https://www.eurosender.com/sl/account/register">{{ $t('here') }}.</a></div>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ShippingService from '@/services/ShippingService'

export default {
  data() {
    return {
      key: '',
      errors: null
    }
  },
  validations: {
    key: { required }
  },
  props: {
    platform: {
      type: String,
      required: true
    }
  },
  methods: {
    sendKeys() {
      ShippingService.postShippingKey({
          key: this.key,
          platform: this.platform
        })
        .then(() => {
          alert('Shipping details saved successfully!')
          this.$emit('exit', true)
        })
        .catch(err => {
          this.errors = err.response.data.response;
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  //position: absolute;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 0px 8px 0px #000;
  width: 100%;
}

.error-boarder {
//   background-color: var(--primarySuperLight) !important;
//   border-color: none;
  border: 0.2px solid var(--primaryDark);
}

a:visited {
  color: #2c3e50;
}

.button,
button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
//   background: linear-gradient(to right, $secondary, $secondary-dark);
  font-size: 1.5em;
  color: white;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  outline: none;
}

button.action:hover {
    opacity: 0.9;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

form {
  display: flex;
  align-items: center;
  flex-direction: column;

  p {
    color: red;
  }
}

input {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-bottom: 1em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

h1 {
  margin-top: 0;
}

.questionMark {
	display: inline;
	color: var(--bright) !important;
	border-radius: 50% !important;
	border: none;
	font-size: 1em;
	background: var(--bg) !important;
	margin:0 0 0 5px;
	padding: 0 8px;
}
.questionMark:hover {
  background-color: var(--primaryDark) !important;
}

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 0.3em;
	border-radius: 5px;
	letter-spacing: 3px;
	width: 80%;
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
  text-align: left;
//   margin-left: 10px;
}
</style>
